// Component style overrides

import { Input } from './input';
import { Heading } from './heading';

export const components = {
  Input,
  Heading,
};
